<template>
  <div style="height: calc(100vh - 135px);overflow: auto;padding-right:3px">
    <div class="page_header" style="">
      <span class="page_title" style="flex: 1;">{{$t('statistics.空调使用统计')}}</span>
      <quickQuery :isDownload="false" @handleQuery="handleQuery" @quickQuery="quickQuery" @download="download" style="text-align: right"/>
    </div>
    <div><el-divider></el-divider></div>
    <div class="page_container">
      <el-table :size="size" border :data="listData" v-loading="loading">
        <el-table-column align="center" prop="ID" :label="$t('public.OrderIndex')" min-width=""></el-table-column>
        <el-table-column align="center" prop="CarNo" :label="$t('statistics.车辆')" min-width=""></el-table-column>
        <el-table-column align="center" prop="RunTime" :label="$t('statistics.车辆运行时间')" min-width="280"></el-table-column>
        <el-table-column align="center" prop="RunDuration" :label="$t('statistics.车辆运行时长(h)')" min-width=""></el-table-column>
        <el-table-column align="center" prop="AirDuration" :label="$t('statistics.空调运行时长(h)')" min-width=""></el-table-column>
        <el-table-column align="center" prop="RunMileage" :label="$t('statistics.车辆行驶里程(km)')" min-width=""></el-table-column>
        <el-table-column align="center" prop="AirMileage" :label="$t('statistics.空调开启里程(km)')" min-width=""></el-table-column>
      </el-table>
    </div>
    <div style="text-align: right ;margin-top:8px" class="pagination" v-show="total>0" >  <!--  -->
        <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import quickQuery from '../components/generalOrQuickQuery.vue'
import { mapState } from 'vuex';
import settings from "@/settings";
export default {
  name: "ACStatistics",
  components:{quickQuery},
  data(){
    return{
      listData:[],
      loading:false,
      vehicles:"",
      beginDate:"",
      endDate:"",
      currentPage:1,
      pageSize:10,
      total:0,
    }
  },
  mounted(){
     const currentPath = this.$route.path
    // 从全局变量中取出对应路由的开始时间
    const startTime = settings.routeStartTime[currentPath]
    if (startTime) {
      // 计算耗时（mounted时组件已挂载到DOM，UI基础展示完成）
      const renderTime = Date.now() - startTime
      console.log(`路由 ${currentPath} 渲染耗时：${renderTime}`)
      // 可选：上报到后端或日志系统
      // reportRenderTime(currentPath, renderTime)

      // 清除已计算的开始时间，避免重复计算
      delete settings.routeStartTime[currentPath]
    }
  },
  computed:{
    size() {
        return this.$store.getters.size
    },
    ...mapState({
        selectedVehicles: state => state.app.vehicles.selectedVehicles,
    }),
  },
  methods:{
    handleCurrentChange(val) {
      // console.log(val);
      this.currentPage = val;
      this.getList();
    },
    handleQuery(val){
      // console.log(val);
      if(val.beginDate == "") {
        this.$message.warning("请选择日期");
        return;
      }
      this.beginDate = val.beginDate + " 00:00:00";
      this.endDate = val.endDate + " 23:59:59";
      this.vehicles = this.getSelectedVehicles();
      this.getList();
    },
    getSelectedVehicles(){
      this.vehicles = "";
      for(let k = 0; k < this.selectedVehicles.length; k++){
        if(this.selectedVehicles[k].treeLevel == 5){
          this.vehicles = this.vehicles + this.selectedVehicles[k].nodeValue + ",";
        }
      }
      return this.vehicles.substring(0,this.vehicles.length-1);
    },
    quickQuery(val){
      // console.log(val);
      this.beginDate = val.beginDate + " 00:00:00";
      this.endDate = val.endDate + " 23:59:59";
      this.vehicles = this.getSelectedVehicles();
      this.getList();
    },
    download(){},
    getList(){
      this.loading = true;
      this.$api.queryAirEnergyInfoWeb({
        vehicles: this.vehicles,
        BeginDate: this.beginDate,// "2025-08-10 00:00:00",
        EndDate: this.endDate,// "2025-08-10 23:59:59",
        PageNo: this.currentPage,
        PageSize: 10,
      })
      .then((res)=>{
        this.listData = res.data;
        this.total = res.recordsTotal;
        this.loading = false;
      })
      .catch((e)=>{
        this.listData = [];
        this.total = 0;
        this.loading = false;
      })
    },
  },

}
</script>
<style  lang="scss" scoped>
.pagination  {
  ::v-deep .el-pagination button:disabled,.el-pager li,.el-pagination .btn-prev, .el-pagination .btn-next{
    background-color: transparent !important;
  }

}
</style>